export default {
    fet: 'fet',
    indication: 'indication',
    examinationMethod: 'examinationMethod',
    uterusPosition: "uterusPosition",
    uterusSize: "uterusSize",
    endometriumIsoTest: "endometriumIsoTest",
    threeDCoronal: "threeD Coronal",
    dopplerStudyType: "dopplerStudyType",
    tripleLinePattern: "tripleLinePattern",
    eT: "eT",
    distanceFromExternalCervicalOsToFundus: "distanceFromExternalCervicalOsToFundus",
    distanceFromExternalCervicalOsToEndometrium: "distanceFromExternalCervicalOsToEndometrium",
    threeDCoronalView: "threeDCoronalViewId",
    adnexaType: "adnexaType",
    finalDescription: "finalDescription",
    uterineArteryPulsatilityIndexDoppler: "uterineArteryPulsatilityIndexDoppler"
}